/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeleventsearchplaceholder3Inputs */

const en_channeleventsearchplaceholder3 = /** @type {(inputs: Channeleventsearchplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search events...`)
};

const de_channeleventsearchplaceholder3 = /** @type {(inputs: Channeleventsearchplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events suchen…`)
};

/**
* | output |
* | --- |
* | "Search events..." |
*
* @param {Channeleventsearchplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeleventsearchplaceholder3 = /** @type {((inputs?: Channeleventsearchplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeleventsearchplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeleventsearchplaceholder3(inputs)
	return de_channeleventsearchplaceholder3(inputs)
});
export { channeleventsearchplaceholder3 as "channelEventSearchPlaceholder" }